import * as React from 'react';
import classnames from 'classnames';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useProductDetailSlots } from '../../../slots/context.js';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { LensesPerBox } from './components/LensesPerBox/LensesPerBox.js';
import { CLPurchaseTypeSelectionBoxes } from './components/CLPurchaseTypeSelectionBoxes/CLPurchaseTypeSelectionBoxes.js';
import { isSinglePurchase, isSubscriptionPurchase } from '../../../types/typeguards.js';
import { ContactLensesSinglePurchase } from './components/ContactLensesSinglePurchase/ContactLensesSinglePurchase.js';
import { ContactLensesSubscriptionPurchase } from './components/ContactLensesSubscriptionPurchase/ContactLensesSubscriptionPurchase.js';
import { ContactLensesRxInfoModal } from './components/ContactLensesRxInfoModal/ContactLensesRxInfoModal.js';
import { CLDeliveryIndicator } from './components/CLDeliveryIndicator/CLDeliveryIndicator.js';
import { ContactLensesCTA } from './components/ContactLensesCTA/ContactLensesCTA.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import { useCLEcommContext } from './context/CLEcommContext.js';
import { PriceSectionContainer } from '../components/PriceSection/PriceSectionContainer.js';

// If you make changes to this file, you must also change the ContactLensesEcommContent component in packages/products
const ContactLensesEcommContent = ({ className , ctaRef  })=>{
    const { isContactLensEnabled  } = useFeatureToggles();
    const { activeVariant: { displayName , isExcludedFromCheckout  } ,  } = useProductData();
    const { Slots  } = useProductDetailSlots();
    const { state  } = useCLEcommContext();
    const { purchaseType  } = state.configurations;
    const { hideRxConfigurator  } = state.configurator;
    const onlinePurchasingAllowed = isContactLensEnabled && !isExcludedFromCheckout;
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('contact-lenses-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        className: "contact-lenses-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(PriceSectionContainer, null), Slots.AfterPrice && /*#__PURE__*/ React.createElement(Slots.AfterPrice, null), /*#__PURE__*/ React.createElement(LensesPerBox, {
        className: "contact-lenses-ecomm-content__package-quantity"
    }), onlinePurchasingAllowed && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLPurchaseTypeSelectionBoxes, {
        className: "contact-lenses-ecomm-content__purchase-type"
    }), isSinglePurchase(purchaseType) && /*#__PURE__*/ React.createElement(ContactLensesSinglePurchase, {
        className: "contact-lenses-ecomm-content__purchase"
    }), isSubscriptionPurchase(purchaseType) && /*#__PURE__*/ React.createElement(ContactLensesSubscriptionPurchase, {
        className: "contact-lenses-ecomm-content__purchase"
    }), !hideRxConfigurator && /*#__PURE__*/ React.createElement(ContactLensesRxInfoModal, {
        className: "contact-lenses-ecomm-content__info-modal"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "contact-lenses-ecomm-content__cta-section"
    }, /*#__PURE__*/ React.createElement(CLDeliveryIndicator, null), /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(ContactLensesCTA, {
        className: "contact-lenses-ecomm-content__cta"
    })), Slots.AfterCTA && /*#__PURE__*/ React.createElement(Slots.AfterCTA, null)));
};

export { ContactLensesEcommContent };
//# sourceMappingURL=ContactLensesEcommContent.js.map
